import React from 'react';
import { useTranslation } from 'react-i18next';
import { THEMES } from './themes';

/**
 * Twin3DControls — heatmap segment, theme picker, grid/labels toggles.
 * Stateless: parent owns the values and setters.
 */
const HEAT_OPTS = [
    { k: 'off', labelKey: 'Off' },
    { k: 'footfall', labelKey: 'Footfall' },
    { k: 'ocr', labelKey: 'OCR %' },
    { k: 'anomaly', labelKey: 'Anomalies' },
];

export default function Twin3DControls({
    theme, setTheme,
    heatmap, setHeatmap,
    showGrid, setShowGrid,
    showLabels, setShowLabels,
}) {
    const { t } = useTranslation();
    return (
        <div className="twin3d-controls">
            <div className="twin3d-ctrl-group">
                <span className="twin3d-eyebrow">{t('HEATMAP')}</span>
                <div className="twin3d-seg">
                    {HEAT_OPTS.map((o) => (
                        <button
                            key={o.k} type="button"
                            className={'twin3d-seg-btn' + (heatmap === o.k ? ' is-on' : '')}
                            onClick={() => setHeatmap(o.k)}
                        >
                            {t(o.labelKey)}
                        </button>
                    ))}
                </div>
            </div>
            <div className="twin3d-ctrl-div" />
            <div className="twin3d-ctrl-group">
                <span className="twin3d-eyebrow">{t('THEME')}</span>
                <div className="twin3d-seg">
                    {Object.entries(THEMES).map(([k, v]) => (
                        <button
                            key={k} type="button"
                            className={'twin3d-seg-btn' + (theme === k ? ' is-on' : '')}
                            onClick={() => setTheme(k)}
                        >
                            {v.label}
                        </button>
                    ))}
                </div>
            </div>
            <div className="twin3d-ctrl-div" />
            <div className="twin3d-ctrl-group twin3d-ctrl-toggles">
                <button
                    type="button"
                    className={'twin3d-pill' + (showGrid ? ' is-on' : '')}
                    onClick={() => setShowGrid(!showGrid)}
                >{t('Grid')}</button>
                <button
                    type="button"
                    className={'twin3d-pill' + (showLabels ? ' is-on' : '')}
                    onClick={() => setShowLabels(!showLabels)}
                >{t('Labels')}</button>
            </div>
        </div>
    );
}
